import { render, staticRenderFns } from "./UploadInboundItemsModal.vue?vue&type=template&id=f8da84f6&scoped=true&"
import script from "./UploadInboundItemsModal.vue?vue&type=script&lang=js&"
export * from "./UploadInboundItemsModal.vue?vue&type=script&lang=js&"
import style0 from "./UploadInboundItemsModal.vue?vue&type=style&index=0&id=f8da84f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8da84f6",
  null
  
)

export default component.exports